import React, {useEffect, useState} from "react";
import Input from "../../common/Input";
import Dropdown from "../../primer/Dropdown";
import AccountingBox from "../../primer/AccountingBox";
import {Col, Row} from "react-bootstrap";
import DateBox from "../../primer/DateBox";
import moment from "moment";
import EditableTable from "../../primer/Editable-Table";

const ComponentPlayground = () => {
    // How to manage on change event and components built-in ERP
    const [someState, setSomeState] = useState({
        someAccountingBox: 0,
        someInput: "", // Save the value of the input
        someDropdown: "", // Save the "value" key of selected dropdown option
        someMultiselectDropdown: [], // Save array of "value" keys of selected multiselect dropdown options

        someDateBox: moment().toDate(), // Datebox with date constructor
        someDateBoxString: moment().format("DD/MM/YYYY"), // Datebox with classic DD/MM/YYYY string constructor
        editableTable: [], // Array of objects data for editable table
    });

    const someOptions = [
        {label: "Empty", value: ""},
        {label: "Option 1", value: "option1"},
        {label: "Option 2", value: "option2"},
        {label: "Option 3", value: "option3"},
    ]

    const editableTableColumns = [
        {
            name: "Input",
            field: "inputField",
            editable: true,
            width: "20%",
            inputType: {
                type: "input",
            }
        },
        {
            name: "Simple Dropdown",
            field: "simpleDropdown",
            editable: true,
            width: "20%",
            inputType: {
                type: "select",
                options: someOptions,
            }
        },
    ]

    // Editable Table re-renderer key
    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [someState.editableTable]);

    useEffect(() => {
        console.log(someState.editableTable)
    }, [someState.editableTable]);

    const handleOnChange = (e, type, keyName) => {
        const prepChange = {};
        if (type === "input") {
            prepChange[keyName] = e.target.value;
        } else if (type === "dropdown") {
            prepChange[keyName] = e.value;
        } else if (type === "msdd") {
            prepChange[keyName] = e.flatMap((o) => o.value);
        } else if (type === "acb") {
            prepChange[keyName] = +e.target.value || 0;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[keyName] = moment(e).toDate();
            } else {
                prepChange[keyName] = moment().toDate();
            }
        } else if (type === "dateboxString") {
            if (moment(e).isValid()) {
                prepChange[keyName] = moment(e).hour(12).format("DD/MM/YYYY"); // hour 10 to put in the middle of the day
            } else {
                prepChange[keyName] = moment().hour(12).format("DD/MM/YYYY");
            }
        }
        console.log(prepChange);
        setSomeState({...someState, ...prepChange});
    }

    const tableFunctions = {
        insert: (e, data) => {
            const initRow = {
                inputField: "",
                simpleDropdown: "",
                ...{
                    [data.field] : data.value,
                }
            }
            const cloneData = someState.editableTable.slice(); // Clones array not objects inside it
            cloneData.push(initRow);
            setSomeState({...someState, editableTable: cloneData});
        },
        update: (data, id, rowIndex) => {
            const cloneData = structuredClone(someState.editableTable); // Clones the whole array
            cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            setSomeState({...someState, editableTable: cloneData});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = structuredClone(someState.editableTable); // Clones the whole array
            cloneData.splice(rowIndex, 1);
            setSomeState({...someState, editableTable: cloneData});
        },
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={3}>
                    {/* ------------------------- Input ------------------------- */}
                    <Input
                        name={"someInput"}
                        label={"Some Input"}
                        value={someState.someInput}
                        onChange={(e) => handleOnChange(e, "input", "someInput")}
                    />
                </Col>
                <Col md={3}>
                    {/* ------------------------- Accounting Box ------------------------- */}
                    <label>Some Accounting Box</label>
                    <AccountingBox
                        name={"someAccountingBox"}
                        key={someState.someAccountingBox}
                        defaultValue={someState.someAccountingBox}
                        onBlur={(e) => handleOnChange(e, "acb", "someAccountingBox")}
                    />
                </Col>
                <Col md={3}>
                    {/* ------------------------- Dropdown ------------------------- */}
                    <Dropdown
                        name={"someDropdown"}
                        label={"Some Dropdown"}
                        options={someOptions}
                        key={someState.someDropdown}
                        defaultValue={someOptions.find((el) => el.value === someState.someDropdown)}
                        onChange={(e) => handleOnChange(e, "dropdown", "someDropdown")}
                    />
                </Col>
                <Col md={3}>
                    {/* ------------------------- Multiselect Dropdown ------------------------- */}
                    <Dropdown
                        name={"someMultiselectDropdown"}
                        label={"Some Multiselect Dropdown"}
                        options={someOptions}
                        key={someState.someMultiselectDropdown}
                        defaultValue={someOptions.filter((el) => someState.someMultiselectDropdown.includes(el.value))}
                        multiSelect={true}
                        onChange={(e) => handleOnChange(e, "msdd", "someMultiselectDropdown")}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    {/* ------------------------- Datebox with date constructor ------------------------- */}
                    <DateBox
                        name={"someDateBox"}
                        label={"Datebox with date constructor"}
                        selected={someState.someDateBox}
                        onChange={(e) => handleOnChange(e, "datebox", "someDateBox")}
                    />
                </Col>
                <Col md={3}>
                    {/* ------------------------- Datebox with string DD/MM/YYYY constructor ------------------------- */}
                    <DateBox
                        name={"someDateBoxString"}
                        label={"Datebox with DD/MM/YYYY constructor"}
                        selected={moment(someState.someDateBoxString, "DD/MM/YYYY").isValid() ? moment(someState.someDateBoxString, "DD/MM/YYYY").toDate() : null}
                        onChange={(e) => handleOnChange(e, "dateboxString", "someDateBoxString")}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={12}>
                    {/* ------------------------- Editable Table ------------------------- */}
                    <EditableTable
                        name={"SomeEditableTable"}
                        columns={editableTableColumns}
                        key={incrKey} // Update it when data gets updated
                        onUpdate={tableFunctions}
                        data={someState.editableTable}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ComponentPlayground;